import { create } from "zustand";

import type { FlatBundle } from "@/lib/types";

type State = {
  bundle: FlatBundle | null;
  selectedSlideIndex: number | null;
  isConverting: boolean;
  error: string | null;
  setBundle: (b: FlatBundle | null) => void;
  setSelected: (idx: number | null) => void;
  setConverting: (busy: boolean) => void;
  setError: (msg: string | null) => void;
  reset: () => void;
};

export const useBundleStore = create<State>((set) => ({
  bundle: null,
  selectedSlideIndex: null,
  isConverting: false,
  error: null,
  setBundle: (b) => set({ bundle: b, selectedSlideIndex: b?.structure[0]?.slide_index ?? null }),
  setSelected: (idx) => set({ selectedSlideIndex: idx }),
  setConverting: (busy) => set({ isConverting: busy }),
  setError: (msg) => set({ error: msg }),
  reset: () => set({ bundle: null, selectedSlideIndex: null, error: null }),
}));
